module.exports = __webpack_public_path__ + "img/HC1002-155.e4c84ab9.jpg";